import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import _ from 'lodash';

export default function GASelectTeamsReducer(state = initialstate.selectedTeams, action) {
	switch (action.type) {
		case types.UPDATE_TEAMS_CHECKED: {
			if (action.data) {
				if (action.value) {
					let teamsSet = new Set([...state, ...action.data]);
					return [...teamsSet]
				}
				if (!action.value) {
					const updatedState = _.difference(state, action.data);
					return updatedState;
				}
				return;
			}
			return state;
		}
		case types.CLEAR_TEAMS_CHECKED:
			return [];
		default:
			return state;
	}
}
